<div class="content">
    <mat-toolbar role="banner" class="app-toolbar mat-elevation-z1">
        <!-- @defer (on immediate;) { -->
        <app-application-toolbar-content />
        <!-- } @placeholder {
        <div></div>
        } -->
    </mat-toolbar>

    <!-- @defer (on idle;) { -->
    <app-main role="main" />
    <!-- } @placeholder (){
    <div style="width:100%;height:100vh;"></div>
    } -->

</div>
<footer class="footer">
    @defer (on viewport; prefetch on idle) {
    <app-footer />
    } @placeholder {
    <div></div>
    }
</footer>
